const Raven = require('raven-js');
const Utils = require('core-helpers/utils.js');

const SentryService = (function(root, doc, undefined) {

    // Private vars
    const filename = 'sentry.service.js';
    const SENTRY_KEY = 'https://45a54af00d554ae28ee9a033eec1415e@sentry.io/1249934';
    const forceSendLocally = false; // For debugging locally set to true

    /**
     * Returns global config for Sentry
     * @return {Object} globalConfig
     */
    const getConfig = () => ({
        release: "6.1.45" || null,
        whitelistUrls: [/local-hp\.internal\.busuu\.com/, /homepage\/statics/, /cdn\.busuu\.com/]
    });

    const canSentryRun = () => {
        return Utils.isProduction() || forceSendLocally;
    };

    const isRavenInitialised = () => Raven.isSetup();

    /**
     * Returns the user info config for Sentry
     * @return {Object} userConfig
     */
    const getUserContext = (user) => ({
        uid: user.uid,
        name: user.name,
        is_premium: user.is_premium,
        lastLogin: user.last_login,
        languages: user.languages,
        countryCode: user.country_code
    });

    /**
     * We only manually capture exceptions as not to overload
     * Sentry with all kinds of errors and go over our allowance.
     * @param  {Error}  error object
     * @param  {Object} extra data
     */
    const captureException = (error, data) => {
        if (!error) {
            return Utils.log(filename, 'captureException() - missing error parameter.');
        }
        if(canSentryRun() && !isRavenInitialised()) {
            return Utils.log(filename, 'Sentry is not initialised.');
        }
        if (canSentryRun()) {
            Raven.captureException(error, {
                extra: {
                    errorData: data
                },
                level: 'error'
            });
        }
    };

    const identifyUser = (user) => {
        const userContext = getUserContext(user);
        Raven.setUserContext(userContext);
    };

    /**
     * This will initialize sentry with the user data
     * We avoid calling Raven.install() here on purpose
     * as we don't want to ever automatically catch exceptions.
     * We will throw them manually to Sentry from our ExceptionService
     * https://github.com/getsentry/raven-js/issues/316
     */
    const init = () => {
        if(canSentryRun()){
            const config = getConfig();
            Raven.config(SENTRY_KEY, config).install();
        }
    };

    return {
        captureException,
        identifyUser,
        init
    };

})(window, document);

module.exports = SentryService;
